
	import Vue from 'vue';
	import Component from 'vue-class-component';

	import pkg from '../../../package.json';
	import TermConditionDialog from '@/components/termCondition/TermConditionDialog.vue';

	/** The Footer of the application with the version from package.json */
	@Component({
		components: {
			TermConditionDialog
		}
	})
	export default class Footer extends Vue {
		termConditionDialog = false;
		accessibilityDialog = false;

		get version() {
			/** The version from package.json */
			const semver = pkg.version;
			const semverArray = semver.split('.');
			semverArray.pop();

			return semverArray.join('.');
		}

		sendMail() {
			const email = 'support@plateforme-article51.zendesk.com';
			const subject = '[Sujet de la demande]';
			const body = 'Saisissez les details de votre demande, un membre de l\'Equipe Plateforme vous repondra dans les meilleurs delais.\nAttention : Veuillez a ne pas inclure des donnees sensibles dans votre mail, une fonctionnalite de partage securise de fichiers existe sur la plateforme.';
			const encodedBody = encodeURIComponent(body).replace(/%0A/g, '%0D%0A');
			window.location.href = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodedBody}`;
		}

		openSupportPanel() {
			window.open(`${window.SUPPORT_SERVICE_URL}`, '_blank', 'noopener noreferrer');
		}
	}
